// The D10 card's heading, shared by the deferred shell and the island so the
// server HTML and the hydrated form carry the same heading. It is indexed page
// copy, not a control: on /hi/dasamsa it stays Devanagari, the script the page
// still ranks for (owner decision 2026-10-08). The card's controls are the
// governed Hinglish in ./_form-copy.ts, which tests/hindi-register.test.ts
// scans whole-file, so the heading lives here instead.
export const DASAMSA_FORM_HEADING = {
  en: "Generate Your Dasamsa Chart (D10)",
  hi: "अपना दशमांश चार्ट (D10) बनाएं",
} as const;
